// The avoir_model_enabled switch as the UI sees it: read once from GET /settings/general (any signed-in user), cached per page load,
// re-read on demand (the Settings card pushes the saved value in). Failure = OFF (the old posting credit note keeps working; nothing new appears).
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import { parseFlag } from './avoirModel.mjs';

let cache = null;        // boolean | null (unknown)
let inflight = null;
const subs = new Set();
const publish = (v) => { cache = v; subs.forEach(fn => fn(v)); };

export function loadAvoirModel(force = false) {
  if (cache != null && !force) return Promise.resolve(cache);
  if (!inflight || force) inflight = Promise.resolve().then(() => api.getGeneralSettings()).then(g => parseFlag(g?.avoir_model_enabled)).catch(() => false).then(v => { inflight = null; publish(v); return v; });
  return inflight;
}
export const setAvoirModel = (v) => publish(!!v);
export const peekAvoirModel = () => cache;
export const resetAvoirModelForTest = () => { cache = null; inflight = null; subs.clear(); };

// null while unknown (callers render nothing new), then true | false
export default function useAvoirModel() {
  const [v, setV] = useState(cache);
  useEffect(() => { subs.add(setV); loadAvoirModel().then(setV); return () => { subs.delete(setV); }; }, []);
  return v;
}
